<template>
  <div class="main">
    <div class="top-tools-bar">
      <div
        @click="showCatalog"
        class="toggle-wrap"
      >
        <img
          src="../assets/img/catalog.png"
          alt=""
        />
        <span>切换目录</span>
      </div>
      <div @click="downloadBtn">
        <img
          src="../assets/img/download.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div class="audio-title">
        {{ fileName }}
      </div>
      <div
        class="record-logo"
        v-show="isAudio"
      >
        <img
          ref="record"
          src="../assets/img/record-new.svg"
          alt=""
        />
      </div>
      <div v-show="!isAudio && fileUrlArr.length > 0">
        <video
          id="video"
          width="100%"
          class="video-js vjs-default-skin vjs-big-play-centered"
          controls
          poster=""
          style="max-height: 400px;"
          controlslist="nodownload"
          :src="fileUrl"
          oncontextmenu="return false"
        >
          <source
            :src="fileUrl"
            type="video/mp4"
          />
        </video>
      </div>
      <!-- <div class="logo">
        <img src="../assets/img/logo.png" alt="" />
      </div> -->
    </div>
    <div
      class="audio-tools"
      v-if="isAudio"
    >
      <div
        class="progress"
        @click="progressChange"
      >
        <div
          class="progress-bar-acitve"
          :style="{ width: playLen }"
        >
          <div
            class="ball"
            @click.stop
            @touchstart="ballTouchStart"
            @touchmove="ballTouchMove"
            @touchend="ballTouchEnd"
          ></div>
        </div>
        <div
          class="progress-bar-cache"
          :style="{ width: cacheLen }"
        ></div>
        <div class="progress-time">
          <span class="time start">{{
            moment(currProgress * 1000).format('m:ss')
          }}</span>
          <span class="time end">{{
            moment(duration * 1000).format('m:ss')
          }}</span>
        </div>
      </div>
      <div class="btns">
        <span @click="speedSecond('back')">
          <img
            src="../assets/img/back.png"
            alt=""
          />
        </span>
        <span @click="catalogChange('prve')">
          <img
            src="../assets/img/prve.png"
            alt=""
          />
        </span>
        <span @click="playAudio">
          <img
            v-if="!playStatus"
            src="../assets/img/start.png"
            alt=""
          />
          <img
            v-else
            src="../assets/img/pause.png"
            alt=""
          />
        </span>
        <span @click="catalogChange('next')">
          <img
            src="../assets/img/next.png"
            alt=""
          />
        </span>
        <span @click="speedSecond('speed')">
          <img
            src="../assets/img/speed.png"
            alt=""
          />
        </span>
      </div>
    </div>
    <div
      class="mask"
      :class="{ show: showMask }"
      @click="showMask = !showMask"
    >
      <img src="https://front.xinjiaoyu.com/app/tips.png" />
    </div>
    <audio
      ref="audio"
      preload="auto"
      :src="fileUrl"
      v-if="isAudio"
    ></audio>
    <audio-list
      @hide="hide"
      v-if="listVisible"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import AudioList from './AudioList';
import api from '@/apis/api';
import { toast, loading, closeLoading, setBrowserUrl } from '@/lib/utils';
import { saveAs } from 'file-saver';
import Video from 'video.js';
import md5 from 'js-md5';
import { decryptByAES } from '@/lib/security';
import { setclientSessionId } from '@/lib/utils';
import 'video.js/dist/video-js.css';

export default {
  name: 'Home',
  data() {
    return {
      fileUrlArr: [],
      currAudioIndex: 0, // 当前音频索引 默认0
      listVisible: false,
      playStatus: false,
      showMask: false,

      duration: 0, // 音频总长度
      currProgress: 0, // 当前播放进度
      cacheProgress: 0, // 当前音频缓存进度

      // 唱片rotate相关
      intervalId: undefined,
      deg: 0,

      isMove: false,
      isload: false,

      // 视频相关
      player: undefined,
    };
  },
  components: {
    AudioList,
  },
  computed: {
    cacheLen() {
      // 缓存长度
      let width = 0;
      width = (this.cacheProgress / this.duration) * 100;
      return width + '%';
    },
    playLen() {
      // 播放长度
      let width = 0;
      width = (this.currProgress / this.duration) * 100;
      return width + '%';
    },
    fileUrl() {
      if (this.fileUrlArr.length) {
        const fileUrl = this.fileUrlArr[this.currAudioIndex].resourceUrl
        return encodeURIComponent(fileUrl).replace(/%2F/g, '/').replace(/%3A/g, ':');
      } else return '';
    },
    fileName() {
      if (this.fileUrlArr.length) {
        return this.fileUrlArr[this.currAudioIndex].listeningResourceName;
      } else return '';
    },
    // 是否音频
    isAudio() {
      const fileType = this.fileUrl.split('.').pop();
      return fileType === 'mp3' || fileType === 'MP3';
    },
  },
  async mounted() {
    if (!this.$route.query.id) return toast('无效数据!', true);
    await this.setSafeCode();
    await this.getAudioList();
    if (this.isAudio) {
      this.canPlayType() && this.initAudioElement();
    } else {
      this.initVideo();
    }
  },
  methods: {
    async setSafeCode() {
      let params = {
        clientSessionId: sessionStorage.sessionId || setclientSessionId(),
        t: Date.now(),
        client: 'h5',
      };
      params.encrypt = md5(params.client + params.clientSessionId + params.t);
      const res = await api.getSafeCode(params);
      sessionStorage.setItem(
        'safeCode',
        decryptByAES(res.data, '6f0c5ba452b24fa28989e9524d77407a')
      );
    },
    initVideo() {
      let type = this.fileUrl.split('.').pop();
      let data = {
        src: this.fileUrl,
        type: `video/${type}`,
      };
      this.player = Video(
        'video',
        {
          controls: true, // 是否显示控制条
          preload: 'auto',
          fluid: true, // 自适应宽高
          language: 'zh-CN', // 设置语言
          muted: false, // 是否静音
          src: data,
          controlBar: {
            // 设置控制条组件
            /* 设置控制条里面组件的相关属性及显示与否
              'currentTimeDisplay':true,
              'timeDivider':true,
              'durationDisplay':true,
              'remainingTimeDisplay':false,
              volumePanel: {
              inline: false,
              }
              */
            /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
            children: [
              {
                name: 'playToggle',
              }, // 播放按钮
              {
                name: 'currentTimeDisplay',
              }, // 当前已播放时间
              {
                name: 'timeDivider',
              }, // 斜杠
              {
                name: 'durationDisplay',
              }, // 总时间
              {
                name: 'progressControl',
              }, // 播放进度条
              {
                // 倍数播放
                name: 'playbackRateMenuButton',
                playbackRates: [0.5, 1, 1.25, 1.5, 2],
              },
              {
                name: 'volumePanel', // 音量控制
                inline: false, // 不使用水平方式
              },
              {
                name: 'FullscreenToggle',
              }, // 全屏
            ],
          },
        },
        function () {
          this.on('loadedmetadata', function () {
            // 获取视频长度
          });
          this.on('ended', function () {
            // videojs.log('播放结束了');
          });
          // 监听播放进度
          this.on('timeupdate', function () { });
        }
      );
    },
    async getAudioList() {
      loading();
      const res = await api.getCatalogByResourceId(this.$route.query.id);
      if (res.code === 200) {
        if (!res.data.length) {
          toast('无效数据!', true);
          return false;
        }
        this.fileUrlArr = res.data;
        this.currAudioIndex = this.fileUrlArr.findIndex((d) => {
          return (
            d.listeningResourceId === this.$route.query.id ||
            d.oldId === this.$route.query.id
          );
        });

        // 没找到的话，默认取索引 0
        if (this.currAudioIndex < 0) {
          this.currAudioIndex = 0
        }
        document.title = this.fileUrlArr[0].listeningCatalogName;
        closeLoading();
        return true;
      } else {
        toast(res.msg, true);
        return false;
      }
    },
    // 检测浏览器是否支持
    canPlayType() {
      let urlArr = this.fileUrl.split('.'),
        type = urlArr[urlArr.length - 1];
      // 'probable'：浏览器最可能支持该类型
      // 'maybe'：可能支持
      // ''：不支持
      if (!this.$refs.audio.canPlayType(`audio/${type}`)) {
        // TODO 弹出提示 该浏览器不支持当前音频格式
        toast('该浏览器不支持当前音频格式, 请更换浏览器', true);
      }
      return this.$refs.audio.canPlayType(`audio/${type}`);
    },
    // 初始化播放器
    initAudioElement() {
      // console.log(this.$refs.audio.networkState)
      this.$refs.audio.oncanplay = (event) => {
        this.isload = true;
        this.duration = event.target.duration;
        this.cacheProgress = event.target.buffered.end(0);
        closeLoading();
      };
      this.$refs.audio.ontimeupdate = (event) => {
        if (this.isMove) return;
        this.duration = event.target.duration;
        this.currProgress = event.target.currentTime;
        if (event.target.buffered.length === 1) {
          this.cacheProgress = event.target.buffered.end(0);
        }
      };
      this.$refs.audio.onwaiting = () => {
        loading();
      };
      this.$refs.audio.onstalled = () => {
        toast('该浏览器不支持当前音频格式, 请更换浏览器', true);
      };
      // this.$refs.audio.onloadeddata = (event) => {
      //   console.log('音频或视频的当前帧已加载，但没有足够数据播放下一帧')
      //   loading()
      // }
      // this.$refs.audio.onprogress = (event) => {
      //   console.log('浏览器正在下载指定的音频或视频')
      //   loading()
      // }
      this.$refs.audio.onended = () => {
        this.playStatus = false;
        // this.catalogChange('next')
      };
    },
    play() {
      this.playStatus = true;
      this.intervalId && clearInterval(this.intervalId);
      this.rotate();
      try {
        const audio = this.$refs.audio;
        audio.type = "audio/mpeg"
        audio.play();
      } catch (error) {
        alert(error);
      }
    },
    pause() {
      this.playStatus = false;
      this.intervalId && clearInterval(this.intervalId);
      this.$refs.audio.pause();
    },
    // 唱片旋转
    rotate() {
      this.intervalId = setInterval(() => {
        if (!this.$refs.record) return;
        this.deg += 0.1;
        this.$refs.record.style.transform = `rotate(${this.deg}deg)`;
        // console.log(this.deg)
      }, 10);
    },
    hide(audioInfo = {}) {
      this.listVisible = false;
      if (audioInfo.listeningResourceId) {
        // this.$router.replace({
        //   name: 'home',
        //   query: {
        //     id: audioInfo.id
        //   }
        // })
        this.currAudioIndex = this.fileUrlArr.findIndex(
          (d) => d.listeningResourceId === audioInfo.listeningResourceId
        );
        this.switchAudioAndVideo();
      }
    },

    // 切换音频|| 视频
    switchAudioAndVideo() {
      if (this.isAudio) {
        this.$nextTick(() => {
          this.catalogChange('');
        });
      } else {
        this.$nextTick(() => {
          if (this.player) {
            this.playVideo();
          } else {
            this.initVideo();
          }
        });
      }
    },

    playVideo() {
      let type = this.fileUrl.split('.').pop();
      let data = {
        src: this.fileUrl,
        type: `video/${type}`,
      };
      this.player.pause();
      this.player.src(data);
      this.player.load(data);
      this.player.play();
    },
    // 显示目录
    showCatalog() {
      this.listVisible = true;
    },
    // 播放/暂停
    playAudio() {
      this.playStatus = !this.playStatus;
      this.playStatus ? this.play() : this.pause();
    },
    // 下载当前音频
    downloadBtn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // this.showMask = true
        toast('请点击右上角选择浏览器打开');
        return false;
      } else {
        this.downloadFile(this.fileUrl);
      }
    },
    downloadFile(filePath) {
      loading();
      fetch(filePath)
        .then((res) => res.blob())
        .then((blob) => {
          closeLoading();
          setTimeout(() => {
            saveAs(
              blob,
              `${this.fileName}.${this.fileUrl.split('.')[this.fileUrl.split('.').length - 1]
              }`
            );
          }, 20);
        });
    },
    // 快进/后退
    speedSecond(type) {
      let currentTime = this.$refs.audio.currentTime;
      type === 'back' ? (currentTime -= 15) : (currentTime += 15);
      if (currentTime <= 0) currentTime = 0;
      if (currentTime >= this.duration) currentTime = this.duration;
      // console.log(currentTime)
      this.$refs.audio.currentTime = this.currProgress = currentTime;
      if (this.playStatus) {
        this.play();
      } else {
        this.pause();
      }
    },
    // 上一首/下一首
    async catalogChange(type = '') {
      this.$nextTick(async () => {
        loading();
        // 清空唱片旋转角度以及进度
        this.deg = 0;
        this.$refs.record.style.transform = 'rotate(0)';
        this.duration = 0;
        this.currProgress = 0;
        // 切换歌曲
        this.pause();
        if (type === 'next') {
          // 下一首
          this.currAudioIndex++;
          if (this.currAudioIndex >= this.fileUrlArr.length)
            this.currAudioIndex = 0; // 如果大于最大值 回到第一个
        } else if (type === 'prve') {
          // 上一首
          this.currAudioIndex--;
          if (this.currAudioIndex < 0)
            this.currAudioIndex = this.fileUrlArr.length - 1; // 如果小于最小值 回到最后一个
        }
        // if (id) {
        //   this.currAudioIndex = this.fileUrlArr.findIndex((d) => d.id === id);
        // }
        setBrowserUrl(this.fileUrlArr[this.currAudioIndex].listeningResourceId);

        if (this.isAudio) {
          await this.$refs.audio.load();
          await this.initAudioElement();
          this.play();
        } else {
          this.$nextTick(() => {
            if (this.player) {
              this.playVideo();
            } else {
              this.initVideo();
            }
          });
        }

        closeLoading();
      });
    },
    // 进度条更改进度
    progressChange(el) {
      let width = document.querySelector('.progress').getBoundingClientRect()
        .width, // 获取进度条总长度
        layerX = el.layerX, // 获取当前手指位置
        playTime = (layerX / width) * this.duration; // 获取播放位置
      this.$refs.audio.currentTime = playTime;
      this.play();
    },
    // 进度球拖拽-开始
    ballTouchStart() {
      this.isMove = true;
    },
    // 进度球拖拽-移动
    ballTouchMove(el) {
      let event = el.touches[0] || el,
        parent = document.querySelector('.progress').getBoundingClientRect();
      // 移动距离
      this.currProgress =
        ((event.clientX - parent.x) / parent.width) * this.duration;
      // console.log(event)
      // console.log(parent)
    },
    // 进度球拖拽-结束
    ballTouchEnd() {
      this.$refs.audio.currentTime = this.currProgress;
      // if (this.playStatus) this.play()
      this.isload && this.play();
      this.isMove = false;
    },
    moment,
  },
};
</script>
<style scoped lang="less">
.main {
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.top-tools-bar {
  height: 44px;
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: space-between;
  padding: 0 1px;

  div {
    padding: 14px;
  }

  img {
    width: 16px;
    height: 16px;
  }

  .toggle-wrap {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;

    span {
      margin-left: 10px;
    }
  }
}

.audio-tools {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 145px;
  background: #fff;
}

.progress {
  position: relative;
  width: 337px;
  height: 2px;
  margin: 0 auto;
  background: #fafafa;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  margin-top: -10px;
}

.progress-bar-acitve {
  position: absolute;
  width: 0px;
  height: 2px;
  background: #0a93fc;
  border-radius: 1px;
  z-index: 1;

  & .ball {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #0a93fc;
    background-clip: padding-box;
    border-radius: 50%;
    right: -16px;
    top: 50%;
    border: 10px solid transparent;
    transform: translateY(-50%);
  }
}

.progress-bar-cache {
  position: absolute;
  width: 0px;
  height: 2px;
  background: #ededed;
  border-radius: 1px;
}

.progress-time {
  position: absolute;
  bottom: -25px;
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 17px;
  color: #c8ccd4;
}

.btns {
  margin-top: 17px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;

  span {
    display: inline-block;
    width: 16px;
    height: auto;
    padding: 10px;
  }

  span+span {
    margin-left: 16px;
  }

  & span:nth-child(1),
  & span:nth-child(5) {
    width: 22px;
    height: 19px;
  }

  & span:nth-child(3) {
    width: 55px;
    height: 55px;
  }
}

//   padding: 40px 56px 0;

.content {
  margin-top: 65px;
  height: calc(100vh - 194px);
  text-align: center;
  box-sizing: border-box;
}

.audio-title {
  font-size: 16px;
  line-height: 28px;
  color: #3b3e42;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.record-logo,
.logo {
  margin: 42px auto 0;
  width: 160px;
  height: 160px;
  transform-origin: center;

  img {
    transform: rotate(0);
  }
}

.logo {
  width: 160px;
  height: auto;
  margin: 30px auto 0;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 3;

  &.show {
    display: block;
  }

  img {
    position: absolute;
    top: 6px;
    right: 28px;
    width: 155px;
    height: 66px;
  }
}
</style>
